import { render } from "./Sponzori.vue?vue&type=template&id=284db5ea&scoped=true"
const script = {}

import "./Sponzori.vue?vue&type=style&index=0&id=284db5ea&scoped=true&lang=css"

import exportComponent from "E:\\Faks Projekti\\ssa_sajt\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284db5ea"]])

export default __exports__